
import { defineComponent,getCurrentInstance, onMounted, reactive, toRefs,watch } from 'vue'
import {useStore} from 'vuex'
import {useRouter,useRoute} from 'vue-router'
import dataJson from '@/assets/json/data.json'
export default defineComponent({
    props:{
        searchHeight:{
            type:Number,
            default:()=>0
        },
        searchBtnHeight:{
            type:Boolean,
            default:()=>false
        },
        topSearch:{
            type:Boolean,
            default:false
        }
    },
    components:{},
    setup(prop,context) {
        const {proxy,appContext} =getCurrentInstance() as any
        const axios =appContext.config.globalProperties.axios
        const router=useRouter()
        const route=useRoute()
        const store =useStore()
        const state:any=reactive({
            currentRoute:route.path,
            inputValue:'',//输入框的值
            showPopover:false,//是否显示popover下拉框
            isHistory:true,
            searchList:[],
            searchHistory:[]
        })
        const methods=reactive({
            handleInputFocus:()=>{
                //  state.showPopover=true
            },
            // 回车
            handleBack:()=>{
                if(state.currentRoute=='/article'){
                    return
                }
                let text=state.inputValue//输入框的内容
                // console.log(store.state.history)
                let list=store.state.history.list
                if(list.indexOf(text)<0&&text!=''){
                    store.commit('history/SET_HISTORY_LIST',[text,...list])
                }
                methods.handleSelectHistory(text)
                store.commit('history/CHANGE_SEARCH_TEXT','')
                store.commit('history/CHANGE_SEARCH_TEXT',text)
                // context.emit('searchValue',text)
            },
            // 获取焦点
            inputFocus:()=>{
                // if(route.path!='/search'){}
                    state.showPopover=true
                    methods.judgeSearch()
                
            },
            // 判断查询
            judgeSearch:()=>{
                // 输入框为空就显示历史，不为空就检索
                if(state.inputValue.length!=0){
                    state.isHistory=false
                    // state.getRetrieveList=[]
                    methods.getRetrieveList()
                }else{
                    state.isHistory=true
                    state.searchHistory=store.state.history.list?.slice(0,10)
                    console.log(state.searchHistory)
                }
            },
            // 检索出的列表
            getRetrieveList:()=>{
                axios.get('/open/search',{
                    key:state.inputValue
                }).then((res:any)=>{
                     if(res.data.code==200){
                        //  console.log(res.data.data,'search')
                         state.searchList=res.data.data.list
                     }
                })
            },
            // 选择下拉列表
            handleSelectItem:(val:any)=>{
                let data=val.current
                let routePath=window.location.href.includes('#')?'#/article/':'article/'
                if(data.type==1){
                    if(data.bookId==route.query.bookId){
                        window.location.replace(`${window.location.origin+window.location.pathname+routePath+data.id}?bookId=${data.bookId}`)
                        window.location.reload()
                    }else{
                        window.open(`${window.location.origin+window.location.pathname+routePath+data.id}?bookId=${data.bookId}`,"_blank") 
                    }
                }else{
                    window.open(dataJson.paas.axiosUrl+data.docPath,'_blank')
                }
                
            },
            handleSelectHistory:(val:any)=>{
                router.push(`/search?filter=${val}`)
            },
            clearText:()=>{
                state.inputValue=''
            },
            inputChange:(val:String)=>{
                // if(route.path!='/search'){}
                    methods.judgeSearch()
                // store.commit('SET_SEARCH_VALUE',val)
            },
            inputBlur:()=>{
                setTimeout(() => {
                    state.showPopover=false
                }, 500);
            },
            getData:()=>{
                // state.inputValue=store.state.searValue
            }
        })
        onMounted(()=>{
            console.log('mounted',route)
            if(route.path=='/search'&&route.query.filter){
                state.inputValue=route.query.filter
                methods.handleBack()
            }
        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
